import Vue from 'vue';
import Vuex from 'vuex';
import build from './build';
import pipeline from './pipeline';
import setting from './setting';
import meeting from './meeting';
import global from './global';

Vue.use(Vuex)

const store = new Vuex.Store({
    ...global,
    modules: {
        pipeline,
        build,
        setting,
        meeting
    }
})

export default store